//TODO: Replace with real data from db

const customerStories = [
  {
    userName: "Susan",
    location: "Dayton, OH",
    title: "Great!",
    content: "UpdateItAll is sooo amazing!  And the developers are cute too!"
  },
  {
    userName: "Sally",
    location: "Daytona Beach, FL",
    title: "Love IT!",
    content: "The Update It All app is just what I needed to take the headache out of managing my business hours updates!"
  },
  {
    userName: "Bob",
    location: "St. Louis, MO",
    title: "Love Them!",
    content: "With COVID rules changing every day and 3 locations to update, this app makes my life so much easier."
  },
  {
    userName: "Joe",
    location: "Portland, OR",
    title: "Super Awesome!",
    content: "What a handy tool, at a fraction of the cost of the others."
  },
  {
    userName: "Sheryl",
    location: "Providence, RI",
    title: "Just OK!",
    content: "Really love the ease of use this app provides.  Just what I need and nothing I don't!"
  }
]

export default customerStories